(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'floatControl',
            [
                'CHROME',
                FloatControlFactory
            ]
        );

    // Factory Method
    function FloatControlFactory(CHROME)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            templateUrl: CHROME.PREFIX + CHROME.PROJECT.CONTROL.FLOAT + CHROME.POSTFIX
        };

    }
})();



